import { createContext } from 'react';
import { Userwithorganisationwithidps } from '@/models';

export const AuthContext = createContext<{
  auth: { token: string; user: Userwithorganisationwithidps } | null;
  setAuth: any;
}>({ auth: null, setAuth: () => {} });
